module.exports = __webpack_public_path__ + "static/img/culture-mission.12323dfe.png";